var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.566,
    height: 22.757,
    viewBox: "0 0 20.566 22.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52162",
    "data-name": "Group 52162",
    transform: "translate(870.761 -7001.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72332",
    "data-name": "Path 72332",
    d: "M151.477,64.081a9.587,9.587,0,1,0,13.576,0L164.967,64l1.665-1.665,1.234,1.234h0a.861.861,0,0,0,1.205-1.205L165.4,58.685a.861.861,0,0,0-1.205,1.205l1.234,1.234-1.78,1.78h0a9.5,9.5,0,0,0-4.506-1.579V59.4h1.722a.861.861,0,1,0,0-1.722H155.7a.861.861,0,0,0,0,1.722h1.722v1.923a9.529,9.529,0,0,0-5.941,2.755Zm14.667,6.8a7.865,7.865,0,1,1-2.3-5.568,7.865,7.865,0,0,1,2.3,5.568Z",
    transform: "translate(-1019.439 6943.464)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72333",
    "data-name": "Path 72333",
    d: "M301.263,201.425v-3.444a.861.861,0,0,0-1.722,0v3.444a1.923,1.923,0,1,0,1.722,0Zm-.718,1.894a.2.2,0,0,1-.287-.287.2.2,0,0,1,.347.144A.2.2,0,0,1,300.546,203.32Z",
    transform: "translate(-1161.562 6811.171)",
    fill: "#f45e29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimer);
export default __webpack_public_path__ + "static/media/icon-timer.f713db4b.svg";
export { ForwardRef as ReactComponent };